export const ACTION_TYPES = {
    ADD_EMPLOYEE: "ADD_EMPLOYEE",
    EDIT_EMPLOYEE: "EDIT_EMPLOYEE",
    DELETE_EMPLOYEE: "DELETE_EMPLOYEE",
    BLOCK_EMPLOYEE: "BLOCK_EMPLOYEE",
    MIGRATE_EMPLOYEE: "MIGRATE_EMPLOYEE",
    ADD_LEGAL_EMPLOYEE: "ADD_LEGAL_EMPLOYEE",
    EDIT_LEGAL_EMPLOYEE: "EDIT_LEGAL_EMPLOYEE",
    DELETE_LEGAL_EMPLOYEE: "DELETE_LEGAL_EMPLOYEE",
    BLOCK_LEGAL_EMPLOYEE: "BLOCK_LEGAL_EMPLOYEE",
    CHANGE_RATES: "CHANGE_RATES",
    CANCEL_RATES: "CANCEL_RATES",
    ADD_BRANCH: "ADD_BRANCH",
    EDIT_BRANCH: "EDIT_BRANCH",
    DELETE_BRANCH: "DELETE_BRANCH",
    HIDE_BRANCH: "HIDE_BRANCH",
    PUSH_BANK_TRANSFER: "PUSH_BANK_TRANSFER",
    PUSH_BULK_BANK_TRANSFER: "PUSH_BULK_BANK_TRANSFER",
    PUSH_S2S_TRANSFER: "PUSH_S2S_TRANSFER",
    PUSH_BULK_S2S_TRANSFER: "PUSH_BULK_S2S_TRANSFER",
    INITIATE_EXCHANGE: "INITIATE_EXCHANGE",
    CONFIRM_INITIATE_TRANSFER: "CONFIRM_INITIATE_TRANSFER",
    APPROVE_TRX: "APPROVE_TRX",
    APPROVE_LIST_TRX: "APPROVE_LIST_TRX",
    MANAGE_AUTO_CONVERSION: "MANAGE_AUTO_CONVERSION",
    EDIT_MERCHANT_INFO: "EDIT_MERCHANT_INFO",
    EDIT_EMPLOYEE_LIMITATION: "EDIT_EMPLOYEE_LIMITATION",
    INITIATE_PAYMENT_REQUEST: "INITIATE_PAYMENT_REQUEST",
    INITIATE_BULK_PAYMENT_REQUEST: "INITIATE_BULK_PAYMENT_REQUEST",
    REQUEST_CARD: "REQUEST_CARD",
    EDIT_CARD: "EDIT_CARD",
    ACTIVATE_DEACTIVATE_CARD: "ACTIVATE_DEACTIVATE_CARD",
    CANCEL_CARD: "CANCEL_CARD",
    REVERSE_TRANSACTION: "REVERSE_TRANSACTION",
}